export default class StickyApartment {
    constructor() {
        this.lastScrollTop = 0;
        this.init();
    }

    scrollHandler() {
        let scrollTop = document.documentElement.scrollTop;

        if ( scrollTop > window.innerHeight && scrollTop < ( document.body.scrollHeight - window.innerHeight - ( window.innerHeight / 10 ) ) ) {
            document.body.classList.add( 'enable-sticky-apartment' );
        } else {
            document.body.classList.remove( 'enable-sticky-apartment' );
        }

        this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }

    init() {
        if ( document.body.classList.contains( 'template-single-apartment' ) === false ) {
            return;
        }

        window.addEventListener( 'scroll', this.scrollHandler );
    }
}